module.exports = __webpack_public_path__ + "img/11069854_L.d90c92cb.png";